import { useRef, useLayoutEffect, useState } from 'react'
import {setCanvasDimensions, startSpinner, stopSpinner} from './spinnerOps.js'

export default function AtomicSpinner({options}){
    const { radius, lineWidth, onClick } = options; 
    const spinnerCanvas1 = useRef(null); 
    const spinnerCanvas2 = useRef(null); 
    const wrapper = useRef(null); 
    const [ready, setReady] = useState(false) //makes sure original canvas dimensions don't distort parent dimensions before measuring

    useLayoutEffect(() => {
        if (radius) {
            let lw = lineWidth || 5; 
            setCanvasDimensions(spinnerCanvas1.current, radius*2 + lw, radius*2 + lw)
            setCanvasDimensions(spinnerCanvas2.current, radius*2 + lw, radius*2 + lw)
        }
        else {
            let d = spinnerCanvas1.current.parentNode.getBoundingClientRect(); //possible issue here
            setCanvasDimensions(spinnerCanvas1.current, d.width, d.height); 
            setCanvasDimensions(spinnerCanvas2.current, d.width, d.height); 
        }
        setReady(true)
        startSpinner(spinnerCanvas1.current, spinnerCanvas2.current, options); 
        return () => stopSpinner(); 
    }, [])

    return (
        <div ref={wrapper} onClick={onClick} className={`${onClick ? 'clickable' : ''} d-flex justify-content-center align-items-center spinner h-100 w-100 position-relative`}>
            <canvas  ref={spinnerCanvas1} style={{display: ready ? 'block' : 'none', position: 'absolute'}}></canvas>
            <canvas  ref={spinnerCanvas2} style={{display: ready ? 'block' : 'none'}}></canvas>
        </div>
    )

}